// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 37.4rem) {
  .style_hide-sm__uKKY0 {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__idscM {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__hfsBI {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__y5TJ6 {
    display: none !important;
  }
}
/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.style_paperContent__YNmhs {
  box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.2), 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.12), 0 0 0.125rem 0 rgba(0, 0, 0, 0.14);
  background-color: var(--colorBackgroundPrimaryDefault);
  width: 100%;
  max-width: 1280px;
  margin: 0 0 1rem 0;
  position: relative;
  display: flex;
  align-items: stretch;
  flex-direction: column;
}
.style_paperContentFlat__H9rzs {
  box-shadow: 0;
  background-color: transparent;
  width: 100%;
  max-width: 1280px;
  margin: 0 1rem;
  position: relative;
  display: flex;
  align-items: stretch;
  flex-direction: column;
}
@media (max-width: 37.4rem) {
  .style_paperContentFlat__H9rzs {
    margin: 0.8rem;
  }
}
.style_paperFullWidth__XxVCj {
  max-width: none;
}
.style_container__b8ijV {
  display: flex;
  width: 100%;
  justify-content: center;
}
.style_headerContainer__wCx6i {
  background: var(--colorBackgroundPrimaryDefault);
}
.style_busyFromPromise__l72io {
  width: 100%;
}
.style_title__dQGYd {
  word-wrap: break-word;
  background-color: var(--colorBackgroundPrimaryDefault);
}
.style_stickied__j5JaG {
  box-shadow: 0 0.0625rem 0.1875rem -0.0625rem rgba(0, 0, 0, 0.34);
}
`, "",{"version":3,"sources":["webpack://./app/resources/styles/media.less","webpack://./app/components/PaperLayout/style.less"],"names":[],"mappings":"AAMA;EACE;IACE,wBAAA;ECLF;AACF;ADQA;EACE;IACE,wBAAA;ECNF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;ADSA;EACE;IACE,wBAAA;ECPF;AACF;AACA;;;;;;;;;;;;EAYE;AA7BF;EACI,qIAAA;EACA,sDAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;AA+BJ;AA5BA;EACI,aAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;AA8BJ;AA7BI;EAAA;IACI,cAAA;EAgCN;AACF;AA7BA;EACI,eAAA;AA+BJ;AA5BA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;AA8BJ;AA3BA;EACI,gDAAA;AA6BJ;AA1BA;EAEI,WAAA;AA2BJ;AAxBA;EACI,qBAAA;EACA,sDAAA;AA0BJ;AAvBA;EACI,gEAAA;AAyBJ","sourcesContent":["//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}","@import \"../../resources/styles/media\";\n@import \"../../resources/styles/colors\";\n\n.paperContent {\n    box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.2), 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.12), 0 0 0.125rem 0 rgba(0, 0, 0, 0.14);\n    background-color: @white;\n    width: 100%;\n    max-width: 1280px;\n    margin: 0 0 1rem 0;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n}\n\n.paperContentFlat {\n    box-shadow: 0;\n    background-color: transparent;\n    width: 100%;\n    max-width: 1280px;\n    margin: 0 1rem;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    @media (max-width: @screen-sm) {\n        margin: 0.8rem;\n    }\n}\n\n.paperFullWidth{\n    max-width: none;\n}\n\n.container {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n}\n\n.headerContainer {\n    background: @white;\n}\n\n.busyFromPromise {\n    // position: absolute; //mark.siedle: Having this positioned absolute made the busy indicators dissappear from the floating PaperLayout header.\n    width: 100%;\n}\n\n.title {\n    word-wrap: break-word;\n    background-color: @white;\n}\n\n.stickied {\n    box-shadow: 0 0.0625rem 0.1875rem -0.0625rem rgba(0, 0, 0, 0.34);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__uKKY0`,
	"hideSm": `style_hide-sm__uKKY0`,
	"visible-sm": `style_visible-sm__idscM`,
	"visibleSm": `style_visible-sm__idscM`,
	"hide-md": `style_hide-md__hfsBI`,
	"hideMd": `style_hide-md__hfsBI`,
	"visible-md": `style_visible-md__y5TJ6`,
	"visibleMd": `style_visible-md__y5TJ6`,
	"paperContent": `style_paperContent__YNmhs`,
	"paperContentFlat": `style_paperContentFlat__H9rzs`,
	"paperFullWidth": `style_paperFullWidth__XxVCj`,
	"container": `style_container__b8ijV`,
	"headerContainer": `style_headerContainer__wCx6i`,
	"busyFromPromise": `style_busyFromPromise__l72io`,
	"title": `style_title__dQGYd`,
	"stickied": `style_stickied__j5JaG`
};
module.exports = ___CSS_LOADER_EXPORT___;
